export const router = {
  HOME: '/',
  STATE: '/state',
};
